import mappingJson from './json/carc-rarc-mapping.json'

export interface CarcRarcMappingEntry {
  rarcs: string[]
  rarcRequired: boolean
}

export type CarcRarcMapping = Record<string, CarcRarcMappingEntry>

export const CARC_RARC_MAPPING: CarcRarcMapping = mappingJson
